<div class="layout-container">
  <div class="no-page-found">
    <h1>404</h1>
    <h3>Sorry , the page not found</h3>
    <p class="text-block">The link you followed probably broken or the page has been removed</p>
  </div>
</div>
